export const getGalleryMeals = (topDishes, meals) => {
  const galleryMeals = [];

  topDishes.map(topDish => {
    if (meals[topDish] && meals[topDish].primaryImageUrl) {
      galleryMeals.push(meals[topDish]);
    }
  });

  for (const meal in meals) {
    if (meals[meal].primaryImageUrl && topDishes.indexOf(meal) === -1 && galleryMeals.length < 10) {
      galleryMeals.push(meals[meal]);
    }

    if (galleryMeals.length === 10) {
      break;
    }
  }

  return galleryMeals;
};



// WEBPACK FOOTER //
// ./helpers/gallery.helper.js